/*
  PriceList_v3.js propTypes
*/

import { arrayOf, shape } from 'prop-types'

import Price_v1 from './Price_v1'

export default arrayOf(shape(Price_v1))
